import { render, staticRenderFns } from "./upgradeEdm.vue?vue&type=template&id=821dcd7c&"
import script from "./upgradeEdm.vue?vue&type=script&lang=js&"
export * from "./upgradeEdm.vue?vue&type=script&lang=js&"
import style0 from "./upgradeEdm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports